import React, {useState} from 'react';

const InputContainer = ({children,inputPlaceholder, inputIcon, inputType, value, onChange}) => {
    const [isFocusedInput, setIsFocusedInput] = useState(false);

    const focusedInput = `input_bg ${isFocusedInput ? 'focused_input' : ''}`;


    return (
        <div className = "input_container">
            <div className = {focusedInput}>
                <img src = {inputIcon} alt = ""/>
                {inputPlaceholder}
            </div>
            <input type = {inputType} className = "send_email_input" onFocus = {() => {
                setIsFocusedInput(true)
            }} onBlur = {(e) => {
                if(e.target.value.length === 0){
                    setIsFocusedInput(false)
                }
            }} value={value} onChange={onChange}/>
            {children}
        </div>
    );
};

export default InputContainer;